/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Contents } from '../../models/contents';

export interface ApiMasterContentGetContentByMenuIdGet$Params {
  id?: number;
}

export function apiMasterContentGetContentByMenuIdGet(http: HttpClient, rootUrl: string, params?: ApiMasterContentGetContentByMenuIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Contents>> {
  const rb = new RequestBuilder(rootUrl, apiMasterContentGetContentByMenuIdGet.PATH, 'get');
  if (params) {
    rb.query('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Contents>;
    })
  );
}

apiMasterContentGetContentByMenuIdGet.PATH = '/api/Master/Content/GetContentByMenuId';
